module.exports = __webpack_public_path__ + "img/results-cookoff-min.6442e619.jpg";